import { render, staticRenderFns } from "./LgFinderPageOrcamento.vue?vue&type=template&id=3c9f36c8"
import script from "./LgFinderPageOrcamento.vue?vue&type=script&lang=js"
export * from "./LgFinderPageOrcamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports